<form
  class="dlg"
  role="dialog"
  aria-modal="true"
  aria-labelledby="dlg-title"
  [formGroup]="form"
  (ngSubmit)="save()"
>
  <header class="dlg__header">
    <h2 id="dlg-title" class="dlg__title">
      {{
        "service_manager.cancel.modal.cancel_service"
          | translate : { default: " Cancelar servicio" }
      }}
    </h2>
    <p class="dlg__subtitle">
      {{
        "service_manager.cancel.modal.description"
          | translate
            : { default: " Elige el motivo de cancelación y quien lo ha cancelado para confirmarlo." }
      }}
    </p>
  </header>

  <section class="dlg__section">
    <label class="dlg__label" for="reason">
      {{
        "service_manager.cancel.modal.reason"
          | translate : { default: "Motivo" }
      }}
    </label>

    <ng-select
      id="reason"
      [items]="reasons"
      bindLabel="code"
      bindValue="id"
      [clearable]="false"
      [searchable]="false"
      placeholder="{{
        'service_manager.cancel.modal.reason_placeholder'
          | translate : { default: 'Selecciona el motivo' }
      }}"
      formControlName="reasonCode"
      class="reason-select"
    >
      <ng-template ng-option-tmp let-item="item">
        {{ "service_manager.cancel.reasons." + item.code | translate }}
      </ng-template>
      <ng-template ng-label-tmp let-item="item">
        {{ "service_manager.cancel.reasons." + item.code | translate }}
      </ng-template>
    </ng-select>
  </section>

  <section
    class="dlg__section"
    *ngIf="otherReasonGuid && form.get('reasonCode')?.value === otherReasonGuid"
  >
    <label class="dlg__label" for="reason">
      {{
        "service_manager.cancel.modal.write_reason"
          | translate : { default: "Motivo" }
      }}
    </label>

    <input
      class="input_form"
      formControlName="reasonText"
      placeholder="{{
        'service_manager.cancel.modal.write_reason'
          | translate : { default: 'Motivo' }
      }}"
    />
  </section>

  <section class="dlg__section">
    <label class="dlg__label" for="reason">
      {{
        "service_manager.cancel.modal.caused_by_label"
          | translate : { default: "¿Quien lo ha cancelado?" }
      }}
    </label>

    <ng-select
      id="cancelType"
      [items]="cancelByOptions"
      bindLabel="labelKey"
      bindValue="value"
      [clearable]="false"
      [searchable]="false"
      placeholder="{{
        'service_manager.cancel.modal.select'
          | translate : { default: 'Selecciona' }
      }}"
      formControlName="causedBy"
      class="reason-select"
    >
      <ng-template ng-option-tmp let-item="item">
        {{ item.labelKey | translate }}
      </ng-template>
      <ng-template ng-label-tmp let-item="item">
        {{ item.labelKey | translate }}
      </ng-template>
    </ng-select>
  </section>

  <div
    class="refund-info"
    *ngIf="form.get('causedBy')?.value === CancelType.CAFLER"
  >
    <tui-svg tuiAlertIcon src="tuiIconInfo"></tui-svg>
    <span>{{ "service_manager.cancel.modal.not_pay_client" | translate }}</span>
  </div>

  <section
    class="dlg__section"
    *ngIf="form.get('causedBy')?.value === CancelType.CLIENT"
  >
    <label class="dlg__question">
      {{
        "service_manager.cancel.modal.refund_lable"
          | translate
            : { default: "Elige el % que quieres que se le cobre al cliente" }
      }}
    </label>

    <div class="pill-group" role="radiogroup" aria-label="caused-by">
      <button
        type="button"
        class="pill"
        *ngFor="let opt of options"
        [class.pill--active]="form.value.percentage === opt.value"
        (click)="form.get('percentage')!.setValue(opt.value)"
        role="radio"
        [attr.aria-checked]="form.value.percentage === opt.value"
      >
        <span class="pill__dot" aria-hidden="true"></span>
        <span class="pill__label">{{ opt.labelKey | translate }}</span>
      </button>
    </div>
  </section>

  <footer class="dlg__footer">
    <button type="button" class="btn btn--ghost" (click)="close()">
      {{ "common.actions.close" | translate : { default: "Cerrar" } }}
    </button>

    <button
      type="submit"
      class="btn btn--confirm"
      [disabled]="form.invalid || saving || reasonsLoading"
    >
      <ng-container *ngIf="saving; else saveLbl">
        <span class="spinner"></span>
      </ng-container>
      <ng-template #saveLbl>
        {{ "common.actions.cancel" | translate : { default: "Cancelar" } }}
      </ng-template>
    </button>
  </footer>
</form>
